<template>
  <div>
    <Breadcrumb :style="{margin: '24px 0'}">
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>管理员管理</BreadcrumbItem>
        <BreadcrumbItem>{{admintitle}}</BreadcrumbItem>
    </Breadcrumb>
    <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
      <div class="head_style">
        <h2>{{admintitle}}</h2>
      </div>
      <div>
        <p ><b>账&nbsp;&nbsp;&nbsp;&nbsp;号</b></p>
        <Input  placeholder="请输入管理员账号" style="width: 300px" v-model="username"></Input>
      </div><br>
      <div>
        <p ><b>密&nbsp;&nbsp;&nbsp;&nbsp;码</b></p>
        <Input  placeholder="请输入管理员账号" style="width: 300px" v-model="password" type="password"></Input>
      </div><br>
      <div>
        <p ><b>确认密码</b></p>
        <Input  placeholder="请输入管理员账号" style="width: 300px" v-model="again_password" type="password"></Input>
      </div><br>
      <div>
        <p ><b>所属角色</b></p>
          <span v-if = "gid != ''">
            <Select v-model="gid" class="input-width" disabled >
                <Option v-for="item in categorylist" :value="item.id" :key="item.id" >{{item.title}}</Option>
            </Select>
          </span>
          <span v-else>
            <Select v-model="gid" class="input-width" >
                <Option v-for="item in categorylist" :value="item.id" :key="item.id" >{{item.title}}</Option>
            </Select>
          </span>

      </div><br><br>
      <div class="button_style">
        <Button type="success" @click="adminUpdate()">提交</Button>
        <Button  @click="adminReturn()">返回</Button>
      </div>
    </Content>
  </div>
</template>
<style scoped>
* {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
p {
  line-height: 30px;
}
.head_style {
  height: 50px;
}
.input-width{
  width: 300px;
}
</style>
<script>
import adminupdate from '@/assets/js/views/admin/adminupdate';

export default {
  ...adminupdate,
};
</script>

